import { useCallback, useEffect, useState } from 'react'
import {
  fetchMyConversationFeedback,
  postConversationFeedback,
  type ConversationFeedback,
} from '../lib/api'

// 自己在這份對話留過的意見（#1446）。送出後與重整後走的是同一份狀態，
// 所以「留完看得到」與「重整後還看得到」不會是兩套邏輯。

export interface ConversationFeedbackState {
  entries: ConversationFeedback[]
  submit: (turn: number, content: string) => Promise<void>
}

export const useConversationFeedback = (conversationId: string | null) => {
  const [entries, setEntries] = useState<ConversationFeedback[]>([])

  useEffect(() => {
    if (!conversationId) {
      setEntries([])
      return undefined
    }
    let alive = true
    // 讀不到就當作還沒留過：回顯失敗不該把整條對話擋在載入中
    void fetchMyConversationFeedback(conversationId)
      .then((res) => alive && setEntries(res.feedback))
      .catch(() => undefined)
    return () => {
      alive = false
    }
  }, [conversationId])

  const submit = useCallback(async (turn: number, content: string) => {
    if (!conversationId) throw new Error('這條對話還沒開始，先問一句再留意見。')
    const created = await postConversationFeedback(conversationId, turn, content)
    setEntries((prev) => [...prev, created])
  }, [conversationId])

  return { entries, submit }
}
